import { uniq } from "underscore";

export default {
	async loaded(state, data) {
		state.pages = uniq([...data.pages], 'id');
		state.loaded = true;
	},
};
